// frontend/src/components/common/IconButton.jsx
import Tooltip from "./Tooltip";
import "./ui.css";

/**
 * Square icon-only button. `label` is required (used for aria-label and, when
 * tooltip is true, as the tooltip text).
 * variant: ghost | secondary | primary | danger; size: sm | md | lg
 */
export default function IconButton({
  label,
  icon,
  children,
  variant = "ghost",
  size = "md",
  tooltip = false,
  tooltipSide = "bottom",
  active = false,
  className = "",
  type = "button",
  ref,
  ...props
}) {
  const btn = (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={`icon-btn icon-btn--${variant} icon-btn--${size}${active ? " is-active" : ""} ${className}`.trim()}
      {...props}
    >
      {icon || children}
    </button>
  );
  return tooltip ? (
    <Tooltip content={label} side={tooltipSide}>
      {btn}
    </Tooltip>
  ) : (
    btn
  );
}
